import type { AreaSet, Area } from './types';

export const DISCOUNT_AREAS: AreaSet = {
  discountDots1: { x: 0.1, y: 0.2, w: 0.55, h: 0.6 },
};

export const NORMAL_AREAS: AreaSet = {
  normalDots1: { x: 0.05, y: 0.05, w: 0.89, h: 0.89 },
};

export const RESTRICTED_NOMINAL_AREAS: Area[] = [
  { x: 0.14, y: 0.38, w: 0.2, h: 0.13 }, // middle left lake
  { x: 0.63, y: 0.18, w: 0.37, h: 0.33 }, // middle right large park
  { x: 0, y: 0, w: 0.35, h: 0.1 }, // top left park and lake
  { x: 0.6, y: 0, w: 0.15, h: 0.12 }, // top right park
  { x: 0.35, y: 0.5, w: 0.14, h: 0.25 }, // central park
  { x: 0.3, y: 0.85, w: 0.25, h: 0.15 }, // bottom center park
  { x: 0.66, y: 0.84, w: 0.13, h: 0.1 }, // bottom right lake
  { x: 0.93, y: 0.91, w: 0.07, h: 0.09 }, // bottom right park
];

export const MAP_NOMINAL_WIDTH = 1080;
export const MAP_NOMINAL_HEIGHT = 1350;
export const STATIC_MAP_IMAGE_URL =
  '/images/accommodation/SSLP/Map_Vertical.svg';
